<template>
  <div>
    <h3 class="text-center mb-4 mt-4">软件授权</h3>
    <page-body>
      <license-list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import LicenseList from './components/List'

export default {
  name: 'AccountLicense',
  components: {
    LicenseList,
  },
  data () {
    return {
      listId: 'licenseList',
    }
  },
}
</script>
